
function AssetsIntro() {
  return (
    <section className="py-16 md:py-24 lg:py-32">
      <div className="container">
        <div className="flex justify-center">
          
          <div className="w-full lg:w-11/12">
            <div>
              <h4 className="mb-80 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold">At GCAD, digital products are not created to exist — they are created to perform.</h4>
              {/* <p className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-3xl font-light">How can intelligence move beyond systems and become a true driver of decisions, growth, and impact?</p> */}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
              <div className="lg:col-span-5">
                <h4 className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold">The Story Behind Our Digital Products</h4>
              </div>
              <div className="lg:col-span-7">
                <div className="text">
                  <h5 className="mb-6 md:mb-8 font-normal leading-relaxed md:leading-loose text-lg md:text-xl lg:text-2xl">
                  </h5>
                  <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    Each product begins with a real challenge: a decision that needs clarity, a system that needs intelligence, or a process that needs structure. We don’t start by asking what can be built; we start by understanding what must be solved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AssetsIntro;